import React from "react";

const technologyData = [
  {
    title: "Node.js",
    id: 1,
    imgSrc: require(`../../assets/images/technology/node_js.png`),
  },
  {
    title: "React.js",
    id: 2,
    imgSrc: require(`../../assets/images/technology/react_js.png`),
  },
  {
    title: "Next.js",
    id: 3,
    imgSrc: require(`../../assets/images/technology/next_js.png`),
  },
  {
    title: "Express.js",
    id: 4,
    imgSrc: require(`../../assets/images/technology/express_js.png`),
  },
  {
    title: "Redis",
    id: 5,
    imgSrc: require(`../../assets/images/technology/redis.png`),
  },
  {
    title: "MongoDB",
    id: 6,
    imgSrc: require(`../../assets/images/technology/mongoDB.png`),
  },
  {
    title: "MySQL",
    id: 7,
    imgSrc: require(`../../assets/images/technology/mysql.png`),
  },
  {
    title: "Microsoft",
    id: 8,
    imgSrc: require(`../../assets/images/technology/SQL_Server.png`),
  },
  {
    title: "Postgre",
    id: 9,
    imgSrc: require(`../../assets/images/technology/postgreSQL.png`),
  },
  {
    title: "MariaDB",
    id: 10,
    imgSrc: require(`../../assets/images/technology/mariaDB.png`),
  },
  {
    title: "CosmosDB",
    id: 11,
    imgSrc: require(`../../assets/images/technology/cosmosDB.png`),
  },
  {
    title: "DynamoDB",
    id: 12,
    imgSrc: require(`../../assets/images/technology/dynamoDB.png`),
  },
  {
    title: "Cassandra",
    id: 13,
    imgSrc: require(`../../assets/images/technology/cassandra.png`),
  },
  {
    title: "Kafka",
    id: 14,
    imgSrc: require(`../../assets/images/technology/kafka.png`),
  },
  {
    title: "ZooKeeper",
    id: 14,
    imgSrc: require(`../../assets/images/technology/zookeeper.png`),
  },
  {
    title: "AWS",
    id: 14,
    imgSrc: require(`../../assets/images/technology/aws.png`),
  },
  {
    title: "Figma",
    id: 14,
    imgSrc: require(`../../assets/images/technology/figma.png`),
  },
  {
    title: "Diagrams",
    id: 14,
    imgSrc: require(`../../assets/images/technology/diagrams.png`),
  },
  {
    title: "Typescript",
    id: 14,
    imgSrc: require(`../../assets/images/technology/typescript.png`),
  },
  {
    title: "Javascript",
    id: 14,
    imgSrc: require(`../../assets/images/technology/javascript.png`),
  },
  {
    title: "HTML5",
    id: 14,
    imgSrc: require(`../../assets/images/technology/html5.png`),
  },
  {
    title: "CSS3",
    id: 14,
    imgSrc: require(`../../assets/images/technology/css3.png`),
  },
  {
    title: "Bootstrap",
    id: 14,
    imgSrc: require(`../../assets/images/technology/bootstrap.png`),
  },
  {
    title: "Material UI",
    id: 14,
    imgSrc: require(`../../assets/images/technology/mui.png`),
  },
  {
    title: "Tailwind",
    id: 14,
    imgSrc: require(`../../assets/images/technology/tailwind.png`),
  },
  {
    title: "Photoshop",
    id: 14,
    imgSrc: require(`../../assets/images/technology/photoshop.png`),
  },
  {
    title: "Illustrator",
    id: 14,
    imgSrc: require(`../../assets/images/technology/illustrator.png`),
  },
];

export default function CounterSection() {
  return (
    <section
      id="cournter-section-three"
      className="cournter-section-three bg-lighter text-center pt-115 rpt-95 pb-70 rpb-50"
    >
      <div className="container-fluid clearfix px-70">
        <div className="section-title mb-55">
          <h2>The Latest Technologies We Lead in the Market</h2>
        </div>
        <div className="d-flex flex-wrap flex-gap-30">
          {technologyData.map(({ title, id, imgSrc }) => (
            <div className="flex-fill" key={id}>
              <div className="success-item circle-style wow fadeInUp delay-0-2s">
                <img src={imgSrc} alt="Gallery" />
                {/* <span className="count-text k" data-speed="5000" data-stop="35">
                  {title}
                </span> */}
                <span className="technology_style">{title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
